import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@common/api/authService';
import { Button, Icon } from '@common/index';
import React, {
    useEffect,
    useRef,
    useState
} from 'react';
import { INIT_SCHEMA } from '../Dashboard/initSchema';
import GetBrand from './GetBrand';
import GetName from './GetName';
import styles from './styles.module.scss';
import { FormItem, FormProps } from './types';

const OnboardingSteps: React.FC<FormProps>[] = [
    GetName,
    GetBrand,
    // Completed
]

const init = async () => {
    try {
        const {data: existingDashboard} = await supabase
            .from('dashboard')
            .select()
        if (existingDashboard?.length) return;
        const sortKey = Date.now();
        const { data: newDashboard, error: createError } = await supabase
            .from('dashboard')
            .insert([{
                title: 'Business overview',
                schema: INIT_SCHEMA,
                sort_key: sortKey
            }])
            .select()
            .single();
    
        if (createError) throw createError;
                  
    } catch (e) {
        console.error("Failed to create default dashboard:", e);
    }
}

const Onboarding: React.FC = () => {
    const {
        closeOnboarding, isOnboardingOpen, logout
    } = useAuth();
    const [currentStep, setCurrentStep] = useState(0);
    const [form, setForm] = useState<FormItem[]>([]);
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (overlayRef.current) {
            overlayRef.current.scrollTo({
                top: overlayRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [currentStep]);


    const onSubmit = async (data: FormItem[]) => {
        const newData = [...form, ...data];
        setForm(newData);
        setCurrentStep(currentStep + 1);
        if (currentStep === 0) {
            init();
        }
    }

    if (!isOnboardingOpen) {
        return null;
    }

    if (currentStep === OnboardingSteps.length) {
        closeOnboarding();
        return null;
    }

    return (
        <div className={styles.onboardingContainer} ref={overlayRef}>
            <div className={styles.messageContainer}>
                {OnboardingSteps.filter((_, index) => index <= currentStep).map((stepComp, index) => {
                    return (
                        <div className={styles.step} key={index}>
                            {React.createElement(stepComp, {
                                values: form,
                                isFinished: currentStep > index,
                                onSubmit,
                            })}
                        </div>
                    )
                })}
                <div style={{minHeight: '25vh', flexShrink: 0}}></div>
            </div>
            <Button 
                style={{
                    position: 'fixed', top: 24, right: 24
                }}
                variant="outline"
                size="2"
                color="gray"
                onClick={logout}
            >
                <Icon name="logout" size={16} color="#1A162F" />
                <span style={{ color: '#1A162F' }}>Log out</span>
            </Button>
        </div>
    );
};

export default Onboarding;